import { ReactComponent as NoneIcon } from '../icons/none.svg'
import Styles from '../Prompt.module.scss'

const InvalidEmbed = ({
  heading = 'Check the share settings of your embed link and try again',
  errorMessage,
}: {
  heading?: string
  errorMessage?: string
}) => (
  <div className={Styles.invalidPhotoContainer}>
    <div className={Styles.iconWrapper}>
      <NoneIcon />
    </div>
    {heading && <p>{heading}</p>}
    <p>{errorMessage}</p>
  </div>
)

export default InvalidEmbed
